import React from 'react';

interface DnsRecord {
  host: string;
  type: string;
  data: string;
}

interface DnsRecordCardProps {
  name: string;
  record: DnsRecord;
}

export const DnsRecordCard: React.FC<DnsRecordCardProps> = ({ name, record }) => {
  return (
    <div className="text-xs bg-white dark:bg-white/5 p-4 rounded-md border border-gray-200 dark:border-white/15">
      <div className="text-gray-900 dark:text-gray-100 font-medium mb-2">{name}</div>
      <div className="text-gray-600 dark:text-gray-400 space-y-1.5">
        <div className="grid grid-cols-[3.5rem_1fr] gap-2">
          <span className="text-gray-500 dark:text-gray-400">Host:</span>
          <span className="break-all">{record.host}</span>
        </div>
        <div className="grid grid-cols-[3.5rem_1fr] gap-2">
          <span className="text-gray-500 dark:text-gray-400">Type:</span>
          <span className="break-all">{record.type}</span>
        </div>
        <div className="grid grid-cols-[3.5rem_1fr] gap-2">
          <span className="text-gray-500 dark:text-gray-400">Data:</span>
          <span className="break-all">{record.data}</span>
        </div>
      </div>
    </div>
  );
};
